/**
 * D-EZ-110 — THE YEAR AS A STORY, at the top of Career → The season: how it
 * began, where it turned, how it ended, the rivalries that ran through it, and
 * the chapter markers in between. Every line is the season arc's
 * (`domain/chapters/arc.ts`), which the year in review carries too.
 */

import type { SeasonArc } from '../../domain/chapters/index.ts';

export default function ArcStory({ arc }: { arc: SeasonArc }) {
  if (arc.chapters.length === 0) return null;
  return (
    <section className="arc" aria-label={`The story of season ${arc.seasonNumber}`}>
      <h3 className="story__h">The story of season {arc.seasonNumber}</h3>
      {(arc.began || arc.turn || arc.ended) && (
        <dl className="arc__shape">
          {arc.began && (
            <div>
              <dt>How it began</dt>
              <dd>{arc.began.text}</dd>
            </div>
          )}
          {arc.turn && (
            <div>
              <dt>The turn</dt>
              <dd>{arc.turn.text}</dd>
            </div>
          )}
          {arc.ended && (
            <div>
              <dt>How it ended</dt>
              <dd>{arc.ended.text}</dd>
            </div>
          )}
        </dl>
      )}
      {arc.rivalries.length > 0 && (
        <div className="arc__rivals">
          <h4>The rivalries that defined it</h4>
          <ul>
            {arc.rivalries.map((r) => <li key={r.text}>{r.text}</li>)}
          </ul>
        </div>
      )}
      <ol className="arc__chapters">
        {arc.chapters.map((c) => (
          <li key={c.mark} className={`arc__chapter arc__chapter--${c.mark}`}>
            <span className="arc__mark">
              {c.title} <span className="arc__race">race {c.raceNumber}</span>
            </span>
            {c.lines.map((l) => <p key={l.text} className="arc__line">{l.text}</p>)}
          </li>
        ))}
      </ol>
    </section>
  );
}
